<div class="template-container">
  <h1>Templates</h1>

    <div class="tbl-bar">
      <span class="tbl-left"></span>
      <span class="tbl-right">
        <button mat-raised-button color="primary" (click)="addTemplate()">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="mat-elevation-z8 full-width-table">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>

      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
        <td mat-cell *matCellDef="let row">{{ row.userId }}</td>
      </ng-container>

      <ng-container matColumnDef="content">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Content</th>
        <td mat-cell *matCellDef="let row">
          <div class="cell-content-wrapper">
            <span class="cell-content">{{ row | statsPipe }}</span>
            <button class="icon-button"
              mat-icon-button
              (click)="copyToClipboard(row)"
              matTooltip="Copy to clipboard">
              <mat-icon>content_copy</mat-icon>
            </button>
            </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="updateTs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Update</th>
        <td mat-cell *matCellDef="let row">
          {{ toDateTs(row.updateTs) | date : "short" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="controls">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row" style="white-space: nowrap">
          <span>
          <button
            mat-icon-button
            matTooltip="Edit"
            (click)="updateTemplate(row)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Delete"
            (click)="deleteTemplate(row.templateId)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

  </div>
